// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"94f577e2","520":"93052f36","736":"6c8f787a","752":"1dd2dbc0","787":"c1772abb"}[chunkId] + ".chunk.js";
};